import React, {useState} from 'react';
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import {Dropdown} from "primereact/dropdown";
import TaskTypeDialog from "../../components/task-type-dialog";

function SelectProject({selectedProject, projects=[], onChange, readOnly}) {
    const translate = useTranslate();
    let options = [{label:translate("select-project"), icon:"assignment", value:-1, className:"p-0"}];
    options = options.concat(projects?.map(e=>({label:e.title, value:e.id, data:e, className:"p-0"})));

    function ItemTemplate(option) {
        return(
            <div className="flex align-items-center border-noround justify-content-between">
                <div className="flex gap-2 align-items-center">
                    <div className="flex align-items-center gap-1">
                        {option?.icon&&<Icon icon={`mi mi:${option.icon}`} className="text-lg"/>}
                        <span className="text-xs">{option?.label}</span>
                    </div>
                </div>

                {/*{option.value>0&&<i className="pi pi-chevron-left text-xs"/>}*/}
            </div>
        )
    }
    return(
        <>
            {readOnly?<div className="p-1 py-2"><ItemTemplate label={selectedProject?.title}/></div>:<Dropdown onChange={(e)=>{onChange(projects.find(t=>t.id===e.value)??null);}} pt={{trigger:()=>({className:"w-1rem"}),panel:()=>({className:"w-12rem"}),input:()=>({className:"p-2"}),item:()=>({className:"p-2"})}} dropdownIcon={<Icon icon="mi mi:keyboard_arrow_down" className="text-lg"/>} collapseIcon={<Icon icon="mi mi:keyboard_arrow_up" className="text-lg"/>} className="border-none shadow-none" options={options} value={selectedProject?.id||-1} valueTemplate={ItemTemplate} itemTemplate={ItemTemplate}/>}
        </>
    )
}

export default SelectProject;